import o from "./any.mjs";
import m from "./array.mjs";
import t from "./boolean.mjs";
import i from "./date.mjs";
import p from "./enum.mjs";
import e from "./float.mjs";
import f from "./integer.mjs";
import a from "./method.mjs";
import n from "./number.mjs";
import s from "./object.mjs";
import $ from "./pattern.mjs";
import u from "./regexp.mjs";
import y from "./required.mjs";
import l from "./string.mjs";
import r from "./type.mjs";
const C = {
  string: l,
  method: a,
  number: n,
  boolean: t,
  regexp: u,
  integer: f,
  float: e,
  array: m,
  object: s,
  enum: p,
  pattern: $,
  date: i,
  url: r,
  hex: r,
  email: r,
  required: y,
  any: o
};
export {
  C as default
};
//# sourceMappingURL=index.mjs.map
